import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApplicantDetails } from '@/types/ApplicantDetails';
import { QuickQuoteState } from '@/types/PlanSummary';

export const initialState: ApplicantDetails = {
  // Initialize the state according to the ApplicantDetails type definition
  clientType: '',
  isSelected: false,
  id: 0,
  planCode: '',
  sumAssured: 0,
  relationship: '',
  idType: '',
  idNo: '',
  gender: '',
  occupationCode: '',
  deductibleAmount: 0,
  name: {
    fullName: '',
    firstName: '',
    lastName: '',
    middleName: '',
    nickName: '',
  },
  dob: '',
  isSmoking: false,
  emails: [],
};

const applicantDetailsSlice = createSlice({
  name: 'applicantDetails',
  initialState,
  reducers: {
    updateMemberSelection: (state, action: PayloadAction<ApplicantDetails>) => {
      let arr: ApplicantDetails[] = state.applicantData;

      if (state.applicantData) {
        if (action.payload.isSelected) {
          arr.push(action.payload);
        } else {
          arr = arr.filter((applicant) => applicant.id !== action.payload.id);
        }
      } else {
        arr = [];
      }
      state.applicantData = arr;
    },
  },
});

export const { updateMemberSelection } = applicantDetailsSlice.actions;

export default applicantDetailsSlice.reducer;
